<div class="stock-checkbox">
      <div *ngFor="let item of availableValues" class="stock-checkbox__option" (click)="onUpdate(item.key)"  [ngClass]="{'selected': isSelected(item.key)}">
        <span class="stock-checkbox__check">
            <i *ngIf="isSelected(item.key)" class="icon icon-check"></i>
        </span>
        <span class="stock-checkbox__label">{{item.value}} <small>({{item.count}})</small></span>
      </div>
</div>